<template>
  <v-container fluid>
    <v-row class="mb-2">
      <v-col cols="6">
        <span class="title font-weight-regular ml-2">{{ $route.meta.title }}</span>
      </v-col>
    </v-row>
    <v-card>
      <v-data-table
        class="table"
        :headers="headersAreas"
        :items="areas"
        disable-sort
        hide-default-footer
      >
        <template v-slot:item.city="{ item }">
          {{ displayCity(item.city_id) }}
        </template>
        <template v-slot:item.actions>
          <v-row justify="center">
            <v-btn
              icon
              text
              small
              class="btn__icon pa-0"
              width="18"
              height="18"
              to="/areas/area-description"
            >
              <v-icon size="large">mdi-eye-outline</v-icon>
            </v-btn>
          </v-row>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Areas',
  data () {
    return {
      headersAreas: [
        {
          text: 'Название',
          value: 'name',
        },
        {
          text: 'Город',
          value: 'city',
        },
        {
          text: '',
          value: 'actions',
          width: '4%',
        },
      ],
    };
  },
  created () {
    this.loadRegions();
  },
  computed: {
    ...mapGetters({
      areas: 'Region/regions',
    }),
  },
  methods: {
    ...mapActions({
      loadRegions: 'Region/getRegions',
    }),
    displayCity (item) {
      switch (item) {
        case 1: return 'Ульяновск';
        case 2: return 'Саранск';
        default: return '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.v-btn{
  text-transform: none;
}
</style>
